module.exports = __webpack_public_path__ + "media/images/emblems/Avusy-coat_of_arms-9c1d198fbba83c86915d43379f41bea9.svg";